module.exports = __webpack_public_path__ + "img/mi-folder.f9679ef2.svg";